import React, { useEffect, useRef, useState } from "react";
import Header from "../Header/Header"; // Adjust the import path as needed
import Footer from "../Footer/Footer"; // Adjust the import path as needed
import Menue from "../Sidemenue/menue";
import { Box, IconButton, Paper, TextareaAutosize, TextField, Typography } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CloseOutlined, SendOutlined, SmartToyOutlined } from "@mui/icons-material";
import { ApiGetAnalytics } from "../../apiService/Core/Apicall";
import AIAssistant from '../../assets/images/AIAssitant.png'
import chatBackground from '../../assets/images/chatgabackground.png'
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../global/config/Reducer";
import { setLou } from "../../global/config/Reducer/LouSlice";
import storage from "../../utils/storage";



// The Layout component will accept children as a prop, ensuring that it's typed properly
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [message, setMessage] = useState("")
    const [chat, setchat] = useState<any[]>([])
    const [isShowloading, setShowloading] = useState<boolean>(false)
    const clientEntityId = storage.getItem('clientEntityId')
    const chatContainerRef = useRef<HTMLDivElement | null>(null);
    const { isChatOpen } = useSelector((state: RootState) => state.lou)
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()



    useEffect(() => {
        setOpen(isChatOpen)
    }, [isChatOpen])

    const handleSendChat = async () => {
        if (!message) {
            return
        }
        setShowloading(true)
        try {
            const data = {
                question: message,
                clientEntityId
            }
            setchat((prev: any) => [
                ...prev,
                {
                    from: "Client",
                    message: message,
                    time: new Date().toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                    }),
                },
            ]);
            setMessage("")

            const res = await ApiGetAnalytics(data)
            if (res.status) {
                setchat((prev: any) => [
                    ...prev,
                    {
                        from: "Server",
                        message: res?.answer,
                        time: new Date().toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                        }),
                    },
                ]);
            }


        } catch (error: any) {
            toast.error(error?.message)
        }
        finally {
            setShowloading(false)
        }
    }
    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTop =
                chatContainerRef.current.scrollHeight;
        }
    }, [chat, isShowloading]);
    return (
        <Box position={'relative'} className='h-100 w-100 p-0 d-flex bg-white'>
            <ToastContainer />
            <Menue />
            <Box className='h-100 w-100' maxHeight={'100vh'} overflow={'auto'} position={'relative'}>
                <Box position='sticky' top='0px' borderBottom='1px solid #0000001A' zIndex={2}><Header></Header></Box>
                <Box className='bg-white p-3' minHeight='calc(100vh - 65px -20px)'>{children}
                </Box>
            </Box>
            {/* 
            {!open && (<Box
                onClick={() => { setOpen(true) }}
                className="lou"
                sx={{
                    position: "fixed",
                    bottom: "2%",
                    right: "2%",
                    zIndex: 99999,
                    display: "inline-flex",
                    background: "linear-gradient(45deg, red, green, blue)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                }}
            >
                <Box component={'img'} className="bg-white p-2" sx={{ boxShadow: '0px 0px 10px black', borderRadius: '500%' }} height={'100px'} src={AIAssistant}></Box>
            </Box>
            )} */}

            {open && (
                <Paper
                    elevation={6}
                    sx={{
                        position: "fixed",
                        bottom: "10%",
                        right: "2%",
                        width: 500,
                        height: 700,
                        borderRadius: '10px',
                        zIndex: 99999,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            background: "var(--primary-color)",
                            color: "#fff",
                            p: 1,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <Box className='d-flex align-items-center' gap={1}>
                            <Box component={'img'} height={'35px'} src={AIAssistant}></Box>

                            <Typography className="text-white fw-bold" variant="h6">Ask Lou</Typography>
                        </Box>
                        <IconButton size="small" onClick={() => dispatch(setLou(false))}>
                            <CloseOutlined sx={{ color: "#fff" }} />
                        </IconButton>
                    </Box>

                    {/* Chat Body */}
                    <Box className='w-100 d-flex flex-column px-0 pt-1' gap={1} height={'100%'} overflow={'auto'} sx={{
                        position: "relative",
                        overflow: "hidden",

                        "&::before": {
                            content: '""',
                            position: "absolute",
                            inset: 0,
                            backgroundImage: `url(${chatBackground})`,
                            backgroundSize: "fill",
                            backgroundPosition: "center",
                            filter: "opacity(30%)",   // 👈 adjust blur here
                            transform: "scale(1)", // prevents edge cut after blur
                            zIndex: 0,
                        },

                        "& > *": {
                            position: "relative",
                            zIndex: 1,
                        },
                    }}>
                        <Box className='d-flex justify-content-end flex-column' overflow={'hidden'} flex={1}>
                            <Box ref={chatContainerRef}
                                className='d-flex flex-column mt-auto px-2' maxHeight={'100%'} gap={2} overflow={'auto'}>
                                {chat?.map((item, index) => (
                                    <Box
                                        key={index}
                                        className='w-100'
                                        display="flex"
                                        justifyContent={item?.from === "Client" ? "flex-end" : "flex-start"}
                                    >
                                        <Box
                                            borderRadius="10px"
                                            className={`${item?.from == "Client" ? "bg-main text-white" : "bg-secondary text-white fw-bold"} p-2 pb-0 }`}
                                            sx={{
                                                maxWidth: "70%",
                                            }}
                                        >
                                            <Typography className='pe-4 mb-0' variant="body2" sx={{
                                                wordBreak: "break-word",
                                                overflowWrap: "break-word",
                                                whiteSpace: "pre-wrap",
                                            }}>{item?.message}</Typography>
                                            <Box className='d-flex flex-column w-100'>
                                                <Typography variant='caption' className='text-end'>{item?.time}</Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                ))}
                                {isShowloading && (
                                    <Box
                                        className="w-100"
                                        display="flex"
                                        justifyContent="flex-start"
                                    >
                                        <Box
                                            borderRadius="8px"
                                            className="bg-secondary"
                                            sx={{
                                                maxWidth: "70%",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                padding: '14px 20px'
                                            }}
                                        >
                                            {[0, 1, 2].map((dot) => (
                                                <Box
                                                    key={dot}
                                                    sx={{
                                                        width: 8,
                                                        height: 8,
                                                        borderRadius: "50%",
                                                        backgroundColor: "#FFFFFF",
                                                        animation: "bounce 1.4s infinite ease-in-out",
                                                        animationDelay: `${dot * 0.2}s`,
                                                        "@keyframes bounce": {
                                                            "0%, 80%, 100%": {
                                                                transform: "scale(0)",
                                                            },
                                                            "40%": {
                                                                transform: "scale(1)",
                                                            },
                                                        },
                                                    }}
                                                />
                                            ))}
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                        <Box className='d-flex align-items-center bg-white p-1 px-2 border-top' overflow={'auto'} gap={1}>
                            {/* <TextField sx={{border:'none !important'}} className='w-100 mt-auto custom-textarea'  value={message} onChange={(e) => { setMessage(e.target.value) }}  placeholder='Explain what you’re looking for…' autoFocus  /> */}
                            <TextField
                                fullWidth
                                multiline
                                maxRows={3}
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Explain what you’re looking for…"
                                autoFocus
                                variant="outlined"
                                sx={{
                                    m: 0,
                                    p: 0,
                                    '& .MuiOutlinedInput-root': {
                                        p: 0,
                                        '& fieldset': {
                                            border: 'none',
                                        },
                                        '&:hover fieldset': {
                                            border: 'none',
                                        },
                                        '&.Mui-focused fieldset': {
                                            border: 'none',
                                        },
                                    },
                                    '& .MuiInputBase-input': {
                                        p: 0,
                                        wordBreak: 'break-word',
                                        whiteSpace: 'pre-wrap',
                                    },

                                }}
                            />
                            <IconButton onClick={handleSendChat} sx={{
                                backgroundColor: "var(--secondary-color)",
                                "&:hover": {
                                    backgroundColor: "var(--secondary-color)", // same color
                                },
                            }}>
                                <SendOutlined className='' sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Box>
                </Paper>
            )}
        </Box>

    )
};

export default Layout;
